import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ReturnStepper from './Stepper';
import styles from './styles.module.scss';
import { Row } from '../../../../../components/Basic/Blocks';
import { Input } from '../../../../../components/Basic/Inputs';

const ReturnStepperInput = ({
  item = {},
  order = {},
  entryItem = {},
  save = () => {},
  addToEntry = {},
  onChange = () => {},
  ...props
}) => {
  const skladName = useSelector((store) => store.ui.skladName.short_name);
  const [data, setData] = useState({});

  useEffect(() => {
    setData(item);
  }, [item]);

  return (
    <>
      <Row>
        <Input
          value={item.real_quantity}
          fontSize="14px"
          textAlign="center"
          width={'35px'}
          readOnly
          styles={styles.bold_input}
          style={{ marginRight: '15px', fontWeight: 600 }}
        />

        <ReturnStepper
          entyQuantity={item.real_quantity}
          item={item}
          order={order}
          save={(v) => {
            setData(v);
            save(v);
          }}
          skladName={skladName}
          onChange={onChange}
          addToEntry={addToEntry}
        />
      </Row>
    </>
  );
};

export default ReturnStepperInput;
